module.exports = __webpack_public_path__ + "static/media/vikala.e9e297f7.png";